import { render, staticRenderFns } from "./ObraDashboardHero.vue?vue&type=template&id=46913c9d"
import script from "./ObraDashboardHero.vue?vue&type=script&lang=js"
export * from "./ObraDashboardHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports